import { render } from "./AddPaymentPopup.vue?vue&type=template&id=3a395a24"
import script from "./AddPaymentPopup.vue?vue&type=script&lang=js"
export * from "./AddPaymentPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__